import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Route } from 'react-router-dom';
import { compose } from 'redux';
import ContextMenu from '../../components/ContextMenu';
import MusicActions from '../../components/MusicActions';
import MusicUtils from '../../actions/musica/music-actions';
import TabsWithPanel from '../../components/TabsWithPanel';
import MyContent from '../../components/MyMusicContent';
import MySongs from '../../components/MySongs';
import Radios from '../../components/Radios';
import Translator from '../../requests/apa/Translator';
import { fetchLoginDynamic } from '../../reducers/user';
import { setResumeData } from '../../actions/resume';
import { doPGMPlaylist, doPGMAlbum } from '../../actions/musica/player-shared-action-creators';
import { doPGMRadio } from '../../actions/musica/player-shared-action-creators';
import { addToContextMenu } from '../../actions/musica/context-menu-actions';
import { setMetricsEvent } from '../../actions/metrics';
import { playFullMedia } from '../../actions/playmedia';
import AnalyticsDimensionSingleton from '../../components/Header/AnalyticsDimensionSingleton';
import Playlist from '../../components/Playlist';
import './styles.scss';
import MusicActionsUtil from '../../utils/music/MusicActionsUtil';
import PLAYERTRACK_TYPE from '../../containers/Music/playerTracksType';
import RibbonsUtil from '../../utils/RibbonsUtil';
import favoriterObserver from "./FavoriterObserver";
import logger from 'src/utils/logger/logger';

const mapStateToProps = state => ({
    user: state.user,
    playerMusica: state.playermusica
});

const mapDispatchToProps = dispatch => ({
    fetchLoginDynamic: email => dispatch(fetchLoginDynamic(email)),
    setResumeData: itemData => dispatch(setResumeData(itemData)),
    onPlayRadio: (index, state) => dispatch(doPGMRadio(index, state)),
    doPGMPlaylist: (index, state) => dispatch(doPGMPlaylist(index, state)),
    doPGMAlbum: (index, state) => dispatch(doPGMAlbum(index, state)),
    addToContextMenu: currentContent => dispatch(addToContextMenu(currentContent)),
    setMetricsEvent: payload => dispatch(setMetricsEvent(payload)),
    playFullMedia: pgm => dispatch(playFullMedia(pgm))
});

class ClaroMusica extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedItem: null,
            isFetching: false
        };
        this.setIsFetching = this.setIsFetching.bind(this);
        this.onFocusCardHandler = this.onFocusCardHandler.bind(this);
        this.handlePlay = this.handlePlay.bind(this);
        this.toggleFollow = this.toggleFollow.bind(this);
        this.toggleMore = this.toggleMore.bind(this);
        this.sendMetric = this.sendMetric.bind(this);
        this.idTimeout = null;
    }

    onFocusCardHandler(selectedItem) {
        const { setResumeData } = this.props;
        let itemData = null;
        const code = this.getNodeFromProps();
        const elements = document.getElementsByClassName('focused');
        if (elements.length > 0) elements[0].classList.remove('focused');
        const selEl = document.getElementById(`card-${selectedItem.id}`);
        logger.debug(selEl);
        if (selEl) {
            selEl.classList.add('focused');
        }
        switch (code) {
            case 'claromusica_listas':
                itemData = {
                    title: selectedItem.title,
                    year: selectedItem.author,
                    rating: selectedItem.rating_code,
                    category: selectedItem.num_tracks || '',
                    duration: selectedItem.duration,
                    description: selectedItem.total_time,
                    crest: selectedItem.total_time,
                    purchaseButtonInfo: true
                };
                break;
            case 'claromusica_radios':
                itemData = {
                    title: selectedItem.name || selectedItem.artist || selectedItem.title,
                    year: selectedItem.band,
                    rating: selectedItem.rating_code,
                    category:
                        selectedItem.dial !== undefined
                            ? `${Translator.get('RADIO', 'Radio')} ${selectedItem.dial}`
                            : '',
                    duration: selectedItem.totalTime,
                    description: selectedItem.total_time
                };
                break;
            case 'claromusica_mimusica':
                itemData = {
                    title: '',
                    year: '',
                    rating: '',
                    category: '',
                    duration: '',
                    description: '',
                    crest: '',
                    purchaseButtonInfo: true
                };
                switch (selectedItem.type) {
                    case 'playlist':
                        const followers =
                            selectedItem.numFollowers !== null
                                ? `${selectedItem.numFollowers} ${Translator.get(
                                        'FOLLOWERS',
                                        'seguidores'
                                    )}`
                                : '';
                        itemData = {
                            ...itemData,
                            title: selectedItem.title,
                            category: selectedItem.numTracks
                                ? `${selectedItem.numTracks} ${Translator.get(
                                        'SONGS',
                                        'canciones'
                                    )}`
                                : '',
                            duration: selectedItem.totalTime,
                            description: `${selectedItem.author}   ${followers}`
                        };
                        break;
                    case 'album':
                        itemData = {
                            title: selectedItem.title,
                            year: selectedItem.artist.join(', '),
                            rating: selectedItem.rating_code,
                            category: selectedItem.numTracks
                                ? `${selectedItem.numTracks} ${Translator.get(
                                        'SONGS',
                                        'canciones'
                                    )}`
                                : '',
                            duration: selectedItem.totalTime,
                            description: selectedItem.total_time,
                            crest: selectedItem.total_time
                        };
                        break;
                    case 'artist':
                        itemData = {
                            ...itemData,
                            title: selectedItem.artist
                        };
                        break;
                    case 'radios':
                        itemData = {
                            ...itemData,
                            title: selectedItem.title,
                            description: `${selectedItem.band} ${selectedItem.dial}`
                        };
                        break;
                    default:
                        if (selectedItem.trackNumber) {
                            selectedItem = {...selectedItem, type: 'song'};
                            this.setState({selectedItem});
                            //is song
                            itemData = {
                                ...itemData,
                                title: selectedItem.title || selectedItem.name,
                                year: selectedItem.artist.join(', '),
                                category: selectedItem.albumName,
                                duration: selectedItem.duration
                            };
                        }
                        itemData = {
                            ...itemData,
                            title: selectedItem.title || selectedItem.name
                        };
                        break;
                }
                break;
                default:
                    break;

        }
        setResumeData({ ...itemData, overWrite: true });
        this.setState({ selectedItem });
    }

    setIsFetching(isFetching) {
        this.setState({ isFetching });
    }

    toggleFollow() {
        const { selectedItem } = this.state;
        const musicRb = new RibbonsUtil();
        musicRb.getIsFavoriteFromApi( selectedItem.type, this.props.user, { contentId: selectedItem.id }).then(response =>{
          if(response.error || (response.success && response.success === false)) {
            logger.error('ClaroMusica toggleFollow err', response.error);
          } else {
            selectedItem.isFollowing = response.isFavorite;
            MusicActionsUtil.toggleFollow(selectedItem)
              .then(result => {
                this.setState(prevState => {
                  return {
                    selectedItem: {
                      ...prevState.selectedItem,
                      isFollowed: !prevState.selectedItem.isFollowing
                    }
                  };
                });
                favoriterObserver.fire();
                logger.debug('ClaroMusica toggleFollow result', result);
              })
              .catch(err => logger.error('ClaroMusica toggleFollow err', err));
          }
        });
    }

    toggleMore() {
        //set data to modal
        const { addToContextMenu } = this.props;
        const { selectedItem } = this.state;

        if (selectedItem) {
            const type = selectedItem.type;
            switch (type) {
                case PLAYERTRACK_TYPE.PLAYLIST:
                case PLAYERTRACK_TYPE.ALBUM:
                    addToContextMenu(selectedItem);
                    break;
                default:
                    addToContextMenu({ song: selectedItem });
                    break;
            }
        }
        const context = this.contextMenu.getWrappedInstance();
        context.showModal();
    }

    handlePlay(index) {
        const { selectedItem } = this.state;
        const { doPGMPlaylist, doPGMAlbum, playFullMedia } = this.props;
        switch (selectedItem.type) {
            case 'playlist':
                return MusicActionsUtil.playContent(selectedItem, doPGMPlaylist, playFullMedia);
            case 'album':
                return MusicActionsUtil.playContent(selectedItem, doPGMAlbum, playFullMedia);
            case 'radio':
                // TODO revisar esto cuando se pueda playear radios
                return this.playRadio();
            default:
                return null;
        }
    }

    playRadio() {
        const { onPlayRadio, playFullMedia } = this.props;
        const { selectedItem } = this.state;
        const pgm = onPlayRadio(selectedItem.url, selectedItem);
        if (pgm && pgm.media && pgm.media.video_url) {
            playFullMedia({
                playerstate: 'PLAYING',
                source: {
                    audiosource: pgm.media.video_url
                },
                ispreview: false,
                islive: true,
                ispip: false
            });
        }
    }

    sendMetric(tabName) {
        const { setMetricsEvent } = this.props;
        const node = this.getNodeFromProps();
        let category = '';
        switch (node) {
            case 'claromusica_listas':
                category = 'listas';
                break;
            case 'claromusica_mimusica':
                category = 'mi musica';
                break;
            case 'claromusica_radios':
                category = 'radios';
                break;
            default:
                break;
        }
        setMetricsEvent({
            hitType: 'event',
            eventCategory: category,
            eventAction: 'click categoria',
            eventLabel: tabName
        });
        setMetricsEvent({ type: 'executor' });
        this.sendDimension();
    }

    sendDimension() {
        const { setMetricsEvent } = this.props;
        const payload = new AnalyticsDimensionSingleton().getPayload();
        setMetricsEvent(payload);
        setMetricsEvent({ type: 'executor' });
    }

    getNodeFromProps() {
        const { match: { params: { code = '' } = {} } = {} } = this.props;
        return code;
    }

    getActionTypeFromNode() {
        const node = this.getNodeFromProps();
        switch (node) {
            case 'claromusica_listas':
            case 'claromusica_mimusica':
                return 'playlists';
            case 'claromusica_radios':
                return 'radios;';
            default:
                return '';
        }
    }

    getComponentsByUserType = (user, isFetching) => {
        const components = [
            <Playlist
                tab={1}
                onFocusCardHandler={this.onFocusCardHandler}
                setIsFetching={this.setIsFetching}
                user={user}
                content="playlist"
            />,
            <Playlist
                tab={2}
                onFocusCardHandler={this.onFocusCardHandler}
                setIsFetching={this.setIsFetching}
                isFetching={isFetching}
                user={user}
                content="playlist"
            />,
            <Playlist
                tab={3}
                onFocusCardHandler={this.onFocusCardHandler}
                setIsFetching={this.setIsFetching}
                isFetching={isFetching}
                content="userPlaylist"
                user={user}
            />,
            <Playlist
                tab={4}
                onFocusCardHandler={this.onFocusCardHandler}
                setIsFetching={this.setIsFetching}
                isFetching={isFetching}
                user={user}
                content="playlist"
            />
        ];
        if (user && user.musicUser && user.musicUser.type !== 2) {
            return components;
        } else {
            return components.slice(1, components.length);
        }
    };

    render() {
        const { isFetching, selectedItem } = this.state;
        const { user, user :{musicUser :{type = 0} = {}} = {}, setMetricsEvent } = this.props;
        let tabs = [
            Translator.get('PLAYLISTS_FREE', 'LISTAS GRATIS'),
            Translator.get('CLARO_MUSICA', 'CLARO MÚSICA'),
            Translator.get('MINE', 'MÍAS'),
            Translator.get('FOLLOWING', 'SIGUIENDO')
        ];

        if (type === 2) {
            tabs = tabs.slice(1, tabs.length)
        }
        const actionType = this.getActionTypeFromNode();

        return (
            <div>
                <ContextMenu
                    ref={instance => {
                        this.contextMenu = instance;
                    }}
                />
                {selectedItem && (
                    <MusicActions
                        actionType={actionType}
                        buttonData={selectedItem}
                        blueAction={this.handlePlay}
                        yellowAction={this.toggleFollow}
                        greenAction={this.toggleMore}
                        isHidden={true}
                        device={MusicUtils.getMusicDevice()}
                    />
                )}
                <Route
                    exact
                    path="/node/claromusica_listas"
                    render={() => (
                        <TabsWithPanel
                            isFetching={isFetching}
                            tabs={tabs}
                            onTabClick={this.sendMetric}
                            tabSize={type === 2 ? 'extra-large' : 'large'}
                        >
                            {this.getComponentsByUserType(user, isFetching)}
                        </TabsWithPanel>
                    )}
                />
                <Route
                    exact
                    path="/node/claromusica_mimusica"
                    render={() => (
                        <TabsWithPanel
                            tabSize="small"
                            isFetching={isFetching}
                            tabs={[
                                Translator.get('PLAYLISTS', 'LISTAS'),
                                Translator.get('SONGS', 'CANCIONES'),
                                Translator.get('ALBUMS', 'ÁLBUMES'),
                                Translator.get('ARTISTS', 'ARTISTAS'),
                                Translator.get('RADIOS', 'RADIOS')
                            ]}
                            onTabClick={this.sendMetric}
                        >
                            <MyContent
                                onFocusCardHandler={this.onFocusCardHandler}
                                setIsFetching={this.setIsFetching}
                                service="favoritePlaylistsByUser"
                                cardType="square"
                                user={user}
                                content="playlist"
                                ref={instance => {
                                    this.myMusic = instance;
                                }}
                            />
                            <MySongs
                                onFocusCardHandler={this.onFocusCardHandler}
                                setIsFetching={this.setIsFetching}
                                user={user}
                                content="song"
                            />
                            <MyContent
                                onFocusCardHandler={this.onFocusCardHandler}
                                setIsFetching={this.setIsFetching}
                                service="favoriteAlbumsByUser"
                                cardType="square"
                                user={user}
                                content="album"
                                ref={instance => {
                                    this.myMusic = instance;
                                }}
                            />
                            <MyContent
                                onFocusCardHandler={this.onFocusCardHandler}
                                setIsFetching={this.setIsFetching}
                                service="favoriteArtistsByUser"
                                cardType="circle"
                                user={user}
                                content="artist"
                                ref={instance => {
                                    this.myMusic = instance;
                                }}
                            />
                            <MyContent
                                onFocusCardHandler={this.onFocusCardHandler}
                                setIsFetching={this.setIsFetching}
                                service="favoriteRadiosByUser"
                                cardType="square"
                                user={user}
                                content="radio"
                                ref={instance => {
                                    this.myMusic = instance;
                                }}
                            />
                        </TabsWithPanel>
                    )}
                />
                <Route
                    exact
                    path="/node/claromusica_radios"
                    render={() => (
                        <TabsWithPanel
                            isFetching={isFetching}
                            tabs={[
                                Translator.get('RADIO_MUSIC', 'ESTACIONES DE MÚSICA'),
                                Translator.get('RADIO_STATION', 'ESTACIONES HABLADAS'),
                                Translator.get('GENRE_RADIOS', 'RADIOS DE GÉNERO'),
                                Translator.get('ARTIST_RADIOS', 'RADIOS DE ARTISTAS')
                            ]}
                            onTabClick={this.sendMetric}
                        >
                            <Radios
                                tab={1}
                                onFocusCardHandler={this.onFocusCardHandler}
                                setIsFetching={this.setIsFetching}
                                service="Radios"
                                user={user}
                                ref={instance => {
                                    this.musicStations = instance;
                                }}
                                setMetricsEvent={setMetricsEvent}
                                stationTitle={'musica'}
                            />
                            <Radios
                                tab={2}
                                onFocusCardHandler={this.onFocusCardHandler}
                                service="Radios"
                                user={user}
                                setIsFetching={this.setIsFetching}
                                ref={instance => {
                                    this.talkStations = instance;
                                }}
                                setMetricsEvent={setMetricsEvent}
                                stationTitle={'habladas'}
                            />
                            <Radios
                                tab={3}
                                onFocusCardHandler={this.onFocusCardHandler}
                                user={user}
                                setIsFetching={this.setIsFetching}
                                setMetricsEvent={setMetricsEvent}
                                stationTitle={'genero'}
                            />
                            <Radios
                                tab={4}
                                onFocusCardHandler={this.onFocusCardHandler}
                                user={user}
                                setIsFetching={this.setIsFetching}
                                setMetricsEvent={setMetricsEvent}
                                stationTitle={'artistas'}
                            />
                        </TabsWithPanel>
                    )}
                />
            </div>
        );
    }
}

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ClaroMusica);



// WEBPACK FOOTER //
// ./src/containers/ClaroMusica/index.jsx